// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z7l3Vgwgg0eEUHnfhonP{border-bottom:none;padding:0}.JoPzs_Qf_sUzh6P7yn3E{margin-top:4px}.PyCt_WUxyCkjGqC8C9c0{padding-left:15px;box-shadow:inset 0 0 0 1px var(--action-outlined-tertiary-border)!important}.eNeDJ3H6eY4dNqMJo7k7{box-shadow:inset 0 0 0 1px var(--content-negative-primary)!important}.EmKkIc9iCJE46L_bxZYY{padding:8px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textInput": `z7l3Vgwgg0eEUHnfhonP`,
	"error": `JoPzs_Qf_sUzh6P7yn3E`,
	"input": `PyCt_WUxyCkjGqC8C9c0`,
	"inputError": `eNeDJ3H6eY4dNqMJo7k7`,
	"dropdownSearchInput": `EmKkIc9iCJE46L_bxZYY`
};
export default ___CSS_LOADER_EXPORT___;
